import { routerPostCall, routerGetCall } from '../../axios';
// authPostCall
const facebookRedirect = (state, params) => {
  const url = `/auth/facebookUser`;
  return routerPostCall(state, url, params);
  // return routerGetCall(state, url, params);
};
export default { facebookRedirect };
